import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, tap } from 'rxjs'
import { DATA_FRESHNESS_REQUEST, DataFreshnessService } from '../core/services/data-freshness.service'

@Injectable()
export class DataFreshnessInterceptor implements HttpInterceptor {
  constructor(private freshness: DataFreshnessService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const freshnessRequest = request.context.get(DATA_FRESHNESS_REQUEST)
    if (!freshnessRequest || request.method !== 'GET') return next.handle(request)

    const requestState = this.freshness.beginRequest(freshnessRequest)
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) this.freshness.recordSuccess(requestState)
      }),
    )
  }
}
